import { createAction, props } from '@ngrx/store';

export const setDidUserSaveVariablesFlag = createAction(
  '[PackageDesigner] Set didUserSaveVariables flag',
  props<{ value: boolean }>(),
);
